
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/george-martins",
      function () {
        return require("private-next-pages/profile/george-martins.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/george-martins"])
      });
    }
  